import { AloftTime, MLS, isDefined } from '@aloft/toolkit-shared';
import { Flex, RadioGroup, Typography } from '@aloft/toolkit-sui';

import { ZillowHomeValueIndexTrendsChart } from './ZillowHomeValueIndexTrendsChart.tsx';
import { ZillowHomeValueIndexTrendsTable } from './ZillowHomeValueIndexTrendsTable.tsx';
import { AnalysisPeriodMonths, ZillowHomeValueIndexTrendsData } from './types.ts';

type ZillowHomeValueIndexTrendsProps = {
  isZillow: boolean;
  analysisPeriodMonths?: AnalysisPeriodMonths;
  setAnalysisPeriodMonths?: (value: AnalysisPeriodMonths) => void;
  timestamp: AloftTime | undefined;
  filteredHousingTrendsData: ZillowHomeValueIndexTrendsData;
};

export const ZillowHomeValueIndexTrends = ({
  analysisPeriodMonths,
  setAnalysisPeriodMonths,
  timestamp,
  filteredHousingTrendsData,
}: ZillowHomeValueIndexTrendsProps) => {
  const attributionParts = [
    timestamp?.formatTime(undefined, 'MMM dd, yyyy, hh:mm aa'),
    ...(filteredHousingTrendsData.sources
      ? filteredHousingTrendsData.sources.map((x) => MLS[x].shortName)
      : []),
  ];
  const attribution = `Data from ${attributionParts.filter(isDefined).join(', ')}`;

  return (
    <>
      <Flex flexDirection="row" width="100%">
        {setAnalysisPeriodMonths && (
          <Flex alignItems="flex-start">
            <RadioGroup
              size="sm"
              items={[
                { value: '6', label: '6 Months' },
                {
                  value: '12',
                  label: '12 Months',
                },
                {
                  value: '24',
                  label: '24 Months',
                },
              ]}
              onChange={(val) => {
                if (val === '') return;
                setAnalysisPeriodMonths(Number(val) as AnalysisPeriodMonths);
              }}
              value={analysisPeriodMonths?.toString()}
              forceHorizontal
              fullWidth={false}
            />
          </Flex>
        )}
        <Flex alignItems="flex-end" marginLeft="auto">
          <Typography variant="body1" textAlign="end">
            {attribution}
          </Typography>
        </Flex>
      </Flex>
      <ZillowHomeValueIndexTrendsTable {...filteredHousingTrendsData} />
      <ZillowHomeValueIndexTrendsChart {...filteredHousingTrendsData} />
    </>
  );
};
